import { render } from "./InvestorGuide.vue?vue&type=template&id=6d49813e&scoped=true"
const script = {}

import "./InvestorGuide.vue?vue&type=style&index=0&id=6d49813e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d49813e"]])

export default __exports__